import { z } from 'zod';
import { SignInIdentifier, TemplateType } from '../../foundations/index.js';
import { VerificationType } from './verification-type.js';
const basicCodeVerificationRecordDataGuard = z.object({
    id: z.string(),
    templateType: z.nativeEnum(TemplateType),
    verified: z.boolean(),
});
export const emailCodeVerificationRecordDataGuard = basicCodeVerificationRecordDataGuard.extend({
    type: z.literal(VerificationType.EmailVerificationCode),
    identifier: z.object({
        type: z.literal(SignInIdentifier.Email),
        value: z.string(),
    }),
});
export const phoneCodeVerificationRecordDataGuard = basicCodeVerificationRecordDataGuard.extend({
    type: z.literal(VerificationType.PhoneVerificationCode),
    identifier: z.object({
        type: z.literal(SignInIdentifier.Phone),
        value: z.string(),
    }),
});
